var React = require('react');

function KeyboardArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"keyboard_arrow_down"),React.createElement("path",{"d":"M7.406 8.578l4.594 4.594 4.594-4.594 1.406 1.406-6 6-6-6z","key":1})]);
}

KeyboardArrowDown.defaultProps = {"version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = KeyboardArrowDown;

KeyboardArrowDown.default = KeyboardArrowDown;
